import { render, staticRenderFns } from "./ManageOrder.vue?vue&type=template&id=2927d76d&scoped=true&"
import script from "./ManageOrder.vue?vue&type=script&lang=js&"
export * from "./ManageOrder.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrder.vue?vue&type=style&index=0&id=2927d76d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927d76d",
  null
  
)

export default component.exports